(function () {
  var html = document.documentElement;
  var modalSelector = '[data-br-pdp-nutrition-modal]';
  var triggerSelector =
    '[data-br-pdp-nutrition-open], .br-pdp-main__acc-body a[href*="/pages/ingredients#nutrition-label"]';
  var focusableSelector = [
    'a[href]',
    'button:not([disabled])',
    'textarea:not([disabled])',
    'input:not([disabled])',
    'select:not([disabled])',
    '[tabindex]:not([tabindex="-1"])',
  ].join(',');

  function prepareTrigger(trigger, modal) {
    trigger.setAttribute('aria-haspopup', 'dialog');
    trigger.setAttribute('aria-controls', modal.id);
    trigger.setAttribute('aria-expanded', 'false');
  }

  function prepareTriggers(modal) {
    document.querySelectorAll(triggerSelector).forEach(function (trigger) {
      prepareTrigger(trigger, modal);
    });
  }

  function resetTriggers(modal) {
    document.querySelectorAll(triggerSelector).forEach(function (trigger) {
      if (trigger.getAttribute('aria-controls') !== modal.id) return;

      trigger.removeAttribute('aria-haspopup');
      trigger.removeAttribute('aria-controls');
      trigger.removeAttribute('aria-expanded');
    });
  }

  function initModal(modal) {
    if (modal.dataset.brPdpNutritionInitialized === 'true') return;
    if (typeof modal.showModal !== 'function') return;

    modal.dataset.brPdpNutritionInitialized = 'true';

    var lastTrigger = null;
    var closeButtons = modal.querySelectorAll('[data-br-pdp-nutrition-close]');

    prepareTriggers(modal);

    function focusableElements() {
      return Array.prototype.slice
        .call(modal.querySelectorAll(focusableSelector))
        .filter(function (element) {
          return element.offsetParent !== null || element === document.activeElement;
        });
    }

    function closeModal() {
      if (!modal.open) return;
      modal.close();
    }

    modal.brPdpNutritionOpen = function (trigger) {
      if (modal.open) return;

      lastTrigger = trigger;
      prepareTrigger(trigger, modal);
      trigger.setAttribute('aria-expanded', 'true');
      html.classList.add('br-pdp-main--nutrition-open');
      modal.showModal();

      window.requestAnimationFrame(function () {
        var closeButton = modal.querySelector('[data-br-pdp-nutrition-close]');
        if (closeButton) {
          closeButton.focus({ preventScroll: true });
        } else {
          modal.focus({ preventScroll: true });
        }
      });
    };

    modal.brPdpNutritionCleanup = function () {
      if (modal.open) modal.close();

      html.classList.remove('br-pdp-main--nutrition-open');
      resetTriggers(modal);
      lastTrigger = null;
    };

    closeButtons.forEach(function (button) {
      button.addEventListener('click', closeModal);
    });

    modal.addEventListener('click', function (event) {
      if (event.target === modal) closeModal();
    });

    modal.addEventListener('cancel', function (event) {
      event.preventDefault();
      closeModal();
    });

    modal.addEventListener('keydown', function (event) {
      if (event.key !== 'Tab') return;

      var focusable = focusableElements();
      if (focusable.length === 0) return;

      var first = focusable[0];
      var last = focusable[focusable.length - 1];
      var active = document.activeElement;

      if (event.shiftKey && active === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && active === last) {
        event.preventDefault();
        first.focus();
      }
    });

    modal.addEventListener('close', function () {
      html.classList.remove('br-pdp-main--nutrition-open');

      if (lastTrigger) {
        lastTrigger.setAttribute('aria-expanded', 'false');
        if (document.contains(lastTrigger)) {
          lastTrigger.focus({ preventScroll: true });
        }
      }

      lastTrigger = null;
    });
  }

  function initModals(root) {
    if (root.matches && root.matches(modalSelector)) initModal(root);
    root.querySelectorAll(modalSelector).forEach(initModal);
  }

  initModals(document);

  if (document.documentElement.dataset.brPdpNutritionDelegated === 'true') return;
  document.documentElement.dataset.brPdpNutritionDelegated = 'true';

  document.addEventListener('click', function (event) {
    if (!(event.target instanceof Element)) return;

    var trigger = event.target.closest(triggerSelector);
    if (!trigger) return;

    var modal = document.querySelector(modalSelector);
    if (!modal || typeof modal.showModal !== 'function') return;

    initModal(modal);
    event.preventDefault();
    modal.brPdpNutritionOpen(trigger);
  });

  document.addEventListener('shopify:section:load', function (event) {
    initModals(event.target);

    var modal = document.querySelector(modalSelector);
    if (modal && modal.brPdpNutritionOpen) {
      prepareTriggers(modal);
    }
  });

  document.addEventListener('shopify:section:unload', function (event) {
    if (!(event.target instanceof Element)) return;

    var modal = event.target.matches(modalSelector)
      ? event.target
      : event.target.querySelector(modalSelector);
    if (!modal) return;

    if (modal.brPdpNutritionCleanup) {
      modal.brPdpNutritionCleanup();
    } else {
      html.classList.remove('br-pdp-main--nutrition-open');
      resetTriggers(modal);
    }
  });
})();
